import { Button } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, MouseEventHandler } from "react";
import { useTranslation } from "../../lib/hooks/useTranslations";

interface FormButtonsProps {
  isLoading?: boolean;
  onPrevious?: MouseEventHandler;
  showSubmit?: boolean;
  className?: string;
}

const FormButtons: FC<FormButtonsProps> = ({
  isLoading,
  onPrevious,
  showSubmit = true,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={clsx("static w-full", className)}>
      <div className="items-center flex justify-between s:justify-start m:mt-3s">
        {onPrevious && (
          <Button
            disabled={isLoading}
            onClick={onPrevious}
            className="mr-s m:mr-m whitespace-nowrap"
            variant="ghost"
            paddingX={false}
            size="md"
          >
            {t("link_back_previous")}
          </Button>
        )}
        {showSubmit && (
          <Button
            type="submit"
            size="md"
            isLoading={isLoading}
            iconEnd="Right"
            data-testid="submit"
          >
            {t("form_button_next")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FormButtons;
